import { render, staticRenderFns } from "./PictureModal.vue?vue&type=template&id=8fa779b2&scoped=true&"
import script from "./PictureModal.vue?vue&type=script&lang=js&"
export * from "./PictureModal.vue?vue&type=script&lang=js&"
import style0 from "./PictureModal.vue?vue&type=style&index=0&id=8fa779b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa779b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
